import { Menu, notification } from "antd";
import React, { useEffect, useState } from "react";
import {
  IoPersonOutline,
  IoExitOutline,
  IoSettingsOutline,
  IoCopyOutline,
  IoPeopleOutline,
  IoCartOutline,
  IoImageOutline,
  IoAppsOutline,
  IoMegaphoneOutline,
  IoAlbumsOutline,
  IoPricetagsOutline,
  IoGridOutline,
  IoBarChartOutline,
  IoLeafOutline,
  IoGolfOutline,
  IoReaderOutline,
  IoRocketOutline,
  IoInformationCircleOutline,
  IoUnlinkOutline,
  IoAddCircleOutline,
  IoCashOutline,
  IoTrendingUp,
  IoBagCheckOutline,
  IoLayersOutline,
  IoDuplicateOutline,
  IoImagesOutline,
  IoListOutline,
  IoImages,
  IoMedicalOutline,
  IoRemove,
  IoSparklesOutline,
  IoOptionsOutline,
  IoFlashOutline,
  IoReload,
  IoCheckmarkCircleOutline,
  IoCallOutline,
  IoStorefrontOutline,
  IoBagAddOutline,
  IoSchool,
  IoCart,
  IoSchoolOutline,
  IoHelpBuoyOutline,
} from "react-icons/io5";
import { PiTruck } from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";
import { logoutAdmin } from "../actions/AuthAction";
import { BsCartPlus } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import { postData } from "../api/request";
import Spinner from "../components/Spinner";
import { PiPrinter } from "react-icons/pi";
import { isPermitted } from "../utils/PermissionManager";

export default function SideMenu() {
  const [loading, setLoading] = useState(false);
  const roles = useSelector((state) => state.auth?.profile?.roles);

  const dispatch = useDispatch();

  console.log(roles);

  let menus = [
    {
      name: "inventory",
      icon: <IoLayersOutline />,
      permitted: isPermitted(roles, ["admin", "inventory", "customercare"]),
      child: [
        {
          name: "product list",
          link: "/products",
          icon: <IoAppsOutline />,
          permitted: isPermitted(roles, ["admin", "inventory", "customercare"]),
        },
        {
          name: "categories",
          link: "/categories",
          icon: <IoGridOutline />,
          permitted: isPermitted(roles, ["admin", "inventory"]),
        },
        {
          name: "brands",
          link: "/brands",
          icon: <IoPricetagsOutline />,
          permitted: isPermitted(roles, ["admin", "inventory"]),
        },
        {
          name: "attributes",
          link: "/attributes",
          icon: <IoOptionsOutline />,
          permitted: isPermitted(roles, ["admin", "inventory"]),
        },
        {
          name: "create product",
          link: "/create-product",
          icon: <IoAddCircleOutline />,
          permitted: isPermitted(roles, ["admin", "inventory"]),
        },
      ],
    },
    {
      name: "crm",
      icon: <IoPeopleOutline />,
      permitted: isPermitted(roles, ["admin", "customercare"]),
      child: [
        {
          name: "customers",
          icon: <IoPeopleOutline />,
          link: "/customers",
          permitted: isPermitted(roles, ["admin", "customercare"]),
        },
        {
          name: "calls",
          icon: <IoCallOutline />,
          link: "/calls",
          permitted: isPermitted(roles, ["admin", "customercare"]),
        },
      ],
    },
    {
      name: "order",
      icon: <IoCartOutline />,
      permitted: isPermitted(roles, ["admin", "customercare"]),
      child: [
        {
          name: "create order",
          icon: <BsCartPlus />,
          link: "/create-order",
          permitted: isPermitted(roles, ["admin", "customercare"]),
        },
        {
          name: "all order",
          icon: <IoCartOutline />,
          link: "/orders",
          permitted: isPermitted(roles, ["admin", "customercare"]),
        },
        {
          name: "pending orders",
          icon: <IoReload />,
          link: "/pending-orders",
          permitted: isPermitted(roles, ["admin", "customercare"]),
        },
        {
          name: "confirmed orders",
          icon: <IoCheckmarkCircleOutline />,
          link: "/confirmed-orders",
          permitted: isPermitted(roles, ["admin", "customercare"]),
        },
        {
          name: "packing orders",
          icon: <IoBagCheckOutline />,
          link: "/packing-orders?scanned=true",
          permitted: isPermitted(roles, ["admin", "customercare"]),
        },
        {
          name: "shipped orders",
          icon: <PiTruck />,
          link: "/shipped-orders",
          permitted: isPermitted(roles, ["admin", "customercare"]),
        },
        {
          name: "delivered orders",
          icon: <IoRocketOutline />,
          link: "/delivered-orders",
          permitted: isPermitted(roles, ["admin", "customercare"]),
        },
      ],
    },

    {
      name: "payments",
      icon: <IoCashOutline />,
      link: "/payments",
      permitted: isPermitted(roles, ["admin", "accountant"]),
    },
    {
      name: "vendors",
      icon: <IoSchoolOutline />,
      link: "/vendors",
      permitted: isPermitted(roles, ["admin", "accountant"]),
    },
    {
      name: "purchase",
      icon: <IoBagAddOutline />,
      link: "/purchase",
      permitted: isPermitted(roles, ["admin", "accountant"]),
    },
    {
      name: "reviews",
      icon: <IoMegaphoneOutline />,
      link: "/reviews",
      permitted: isPermitted(roles, ["admin"]),
    },
    {
      name: "support",
      icon: <IoHelpBuoyOutline />,
      link: "/support",
      permitted: isPermitted(roles, ["admin", "customercare"]),
    },
    {
      name: "report",
      icon: <IoTrendingUp />,
      permitted: isPermitted(roles, ["admin", "accountant"]),
      child: [
        {
          name: "order",
          icon: <IoBagCheckOutline />,
          link: "/order-report",
          permitted: isPermitted(roles, ["admin", "accountant"]),
        },
        {
          name: "customer",
          icon: <IoPersonOutline />,
          link: "/customer-report",
          permitted: isPermitted(roles, ["admin", "accountant"]),
        },
        {
          name: "product",
          icon: <IoBagCheckOutline />,
          link: "/product-report",
          permitted: isPermitted(roles, ["admin", "accountant"]),
        },
      ],
    },
  ];

  return (
    <div>
      <Link to="/">
        <img
          // src="https://tranontwebsite.s3.us-west-2.amazonaws.com/icons/Tranont_PrimaryLogo_Horizontal_Tranont_PrimaryLogo_Horizontal_Black.png"
          src={require("../assets/logo.png")}
          style={{
            width: "100%",
            objectFit: "contain",
            padding: "16px 8px 8px 16px",
            height: 120,
          }}
          alt=""
        />
      </Link>
      <Menu
        theme="light"
        mode="inline"
        // defaultOpenKeys={["inventory"]}
        style={{ padding: "8px" }}
      >
        <Menu.Item
          key="/dashboard"
          icon={
            <IoBarChartOutline style={{ fontSize: "14px", width: "18px" }} />
          }
        >
          <Link to={"/"}>Dashboard</Link>
        </Menu.Item>

        {menus
          .filter((lm) => lm.permitted)
          .map((element) => {
            if (element.child?.length > 0) {
              return (
                <Menu.SubMenu
                  key={element.name}
                  icon={element.icon}
                  title={element.name}
                  style={{ textTransform: "capitalize" }}
                >
                  {element.child
                    .filter((elx) => elx.permitted)
                    .map((menu) => (
                      <Menu.Item key={menu.name} icon={menu.icon}>
                        {menu.link ? (
                          <Link
                            to={menu.link}
                            style={{ textTransform: "capitalize" }}
                          >
                            {menu.name}
                          </Link>
                        ) : (
                          <div
                            className="flex"
                            style={{
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            onClick={() => {
                              menu.action();
                            }}
                          >
                            <div style={{ textTransform: "capitalize" }}>
                              {menu.name}
                            </div>
                            {loading ? (
                              <Spinner noStyle={true} size={18} />
                            ) : (
                              <IoAddCircleOutline size={18} />
                            )}
                          </div>
                        )}
                      </Menu.Item>
                    ))}
                </Menu.SubMenu>
              );
            } else {
              return (
                <Menu.Item key={element.name} icon={element.icon}>
                  <Link
                    to={element.link}
                    style={{ textTransform: "capitalize" }}
                  >
                    {element.name}
                  </Link>
                </Menu.Item>
              );
            }
          })}

        {isPermitted(roles, ["admin", "marketer"]) && (
          <Menu.SubMenu
            key="appearance"
            icon={<IoLeafOutline />}
            title={"Appearance"}
            style={{ textTransform: "capitalize" }}
          >
            <Menu.Item
              key="/banner/desktopslider"
              icon={
                <IoImageOutline style={{ fontSize: "14px", width: "18px" }} />
              }
            >
              <Link to={"/banner/desktopslider"}>Desktop Banner</Link>
            </Menu.Item>
            <Menu.Item
              key="/banner/mobileslider"
              icon={<IoImages style={{ fontSize: "14px", width: "18px" }} />}
            >
              <Link to={"/banner/mobileslider"}>Mobile Banner</Link>
            </Menu.Item>
            <Menu.Item
              key="/banner/dualbanner"
              icon={
                <IoImagesOutline style={{ fontSize: "14px", width: "18px" }} />
              }
            >
              <Link to={"/banner/dualbanner"}>Dual Banner</Link>
            </Menu.Item>
            <Menu.Item
              key="/banner/quadbanner"
              icon={
                <IoGridOutline style={{ fontSize: "14px", width: "18px" }} />
              }
            >
              <Link to={"/banner/quadbanner"}>Quad Banner</Link>
            </Menu.Item>
            <Menu.Item
              key="/banner/popup"
              icon={
                <IoAlbumsOutline style={{ fontSize: "14px", width: "18px" }} />
              }
            >
              <Link to={"/banner/popup"}>Popup</Link>
            </Menu.Item>
          </Menu.SubMenu>
        )}

        {isPermitted(roles, ["admin", "marketer"]) && (
          <Menu.SubMenu
            key="promotions"
            icon={<IoGolfOutline />}
            title={"Promotion"}
          >
            <Menu.Item
              key="/campaigns"
              icon={
                <IoFlashOutline style={{ fontSize: "14px", width: "18px" }} />
              }
            >
              <Link to={"/campaigns"}>Campaigns</Link>
            </Menu.Item>
            <Menu.Item
              key="/coupon"
              icon={
                <IoPricetagsOutline
                  style={{ fontSize: "14px", width: "18px" }}
                />
              }
            >
              <Link to={"/coupon"}>Coupon</Link>
            </Menu.Item>
          </Menu.SubMenu>
        )}

        {isPermitted(roles, ["admin", "marketer"]) && (
          <Menu.SubMenu
            key="settings"
            icon={<IoSettingsOutline />}
            title={"Settings"}
            style={{ textTransform: "capitalize" }}
          >
            <Menu.Item
              key={"/settings/announcement"}
              icon={<IoRemove style={{ fontSize: "14px", width: "18px" }} />}
            >
              <Link
                to={`/settings/announcement`}
                style={{ textTransform: "capitalize" }}
              >
                Top Bar
              </Link>
            </Menu.Item>
            <Menu.Item
              key={"businessinfo"}
              icon={
                <IoInformationCircleOutline
                  style={{ fontSize: "14px", width: "18px" }}
                />
              }
            >
              <Link
                to={`/settings/business-info`}
                style={{ textTransform: "capitalize" }}
              >
                Business Info
              </Link>
            </Menu.Item>
            <Menu.Item
              key={"/settings/delivery-charge"}
              icon={<IoRemove style={{ fontSize: "14px", width: "18px" }} />}
            >
              <Link
                to={`/settings/delivery-charge`}
                style={{ textTransform: "capitalize" }}
              >
                Delivery Charge
              </Link>
            </Menu.Item>
            <Menu.Item
              key={"social-links"}
              icon={
                <IoUnlinkOutline style={{ fontSize: "14px", width: "18px" }} />
              }
            >
              <Link
                to={`/settings/social-link`}
                style={{ textTransform: "capitalize" }}
              >
                Social Links
              </Link>
            </Menu.Item>
          </Menu.SubMenu>
        )}

        {isPermitted(roles, ["admin"]) && (
          <Menu.Item
            key="/admins"
            icon={
              <IoPeopleOutline style={{ fontSize: "14px", width: "18px" }} />
            }
          >
            <Link to={"/admins"}>Admins</Link>
          </Menu.Item>
        )}

        <Menu.Item
          key="/profile "
          icon={<IoPersonOutline style={{ fontSize: "14px", width: "18px" }} />}
        >
          <Link to={"/profile"}>Profile</Link>
        </Menu.Item>
        <Menu.Item
          key="/logout"
          onClick={() => {
            dispatch(
              logoutAdmin(() => {
                window.location.href = "/";
              })
            );
          }}
          icon={<IoExitOutline style={{ fontSize: "16px", width: "18px" }} />}
        >
          Logout
        </Menu.Item>
      </Menu>
    </div>
  );
}
